import { render } from "./payment.vue?vue&type=template&id=fa0ceca2&ts=true"
import script from "./payment.vue?vue&type=script&lang=ts"
export * from "./payment.vue?vue&type=script&lang=ts"

import "./payment.vue?vue&type=style&index=0&id=fa0ceca2&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__